/**
 * Single source of truth for a user's "home" page based on their role.
 * Used by:
 *   - Login redirect (`pages/Login.jsx`)
 *   - Root redirect when authed (`App.js` AuthAwareRootRedirect)
 *   - "Should the back button be shown?" gate on landing pages
 *     (`pages/LabBatches.jsx`, `pages/DiamondVerification.jsx`)
 *
 * Adding a new role's default landing: add one line here — every consumer
 * picks it up automatically.
 */

export const HOME_BY_ROLE = {
  broker:                     '/solitaire-procurement',
  cashier:                    '/gold-prices',
  metal_inventory_assistant:  '/lab-batches',
  diamond_dept:               '/diamond-verification',
  salesman:                   '/dashboard',
  stock_supervisor:           '/dashboard',
  crm:                        '/dashboard',
};

export const DEFAULT_HOME = '/messenger';

export const getHomePathForRole = (role) => HOME_BY_ROLE[role] || DEFAULT_HOME;

/**
 * True if the given path is the user's home page.
 * Used to decide whether to render the back-arrow (a back button on your
 * own home is a dead-end — best to hide it).
 */
export const isHomePathForRole = (pathname, role) =>
  pathname === getHomePathForRole(role);
